import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import MarketingLayout from "../../components/marketing/MarketingLayout";
import { LineMask, SectionTag } from "../../components/marketing/Reveal";

// EDIT HERE — company details used across all legal pages
export const LEGAL = {
  entity: "OrthoPlaniX Treatment Planning",
  address: "[Registered address — EDIT HERE]",
  email: "hello@orthoplanix.com",
  jurisdiction: "[Governing law jurisdiction — EDIT HERE]",
  updated: "12 September 2026",
};

const LINKS = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/cookies", label: "Cookie Policy" },
  { to: "/terms", label: "Terms of Service" },
];

export default function LegalLayout({ tag, title, accent, intro, sections, children }) {
  return (
    <MarketingLayout>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        <section className="pt-40 pb-12">
          <div className="max-w-4xl mx-auto px-6 lg:px-10">
            <SectionTag>{tag}</SectionTag>
            <h1 className="font-display font-black tracking-tight leading-[0.98] text-[clamp(2.4rem,5.5vw,4.5rem)]">
              <LineMask delay={0.1}>{title}</LineMask>
              {accent && <LineMask delay={0.25} className="text-neon">{accent}</LineMask>}
            </h1>
            <p className="mt-6 text-xs uppercase tracking-[0.25em] text-slate-500">Last updated · {LEGAL.updated}</p>
            {intro && <p className="mt-6 text-slate-400 text-sm md:text-base leading-relaxed">{intro}</p>}
            <nav className="mt-8 flex flex-wrap gap-2" aria-label="Legal documents">
              {LINKS.map((l) => (
                <Link key={l.to} to={l.to} className="rounded-full border border-white/15 px-4 py-1.5 text-xs font-semibold text-slate-300 hover:border-neon hover:text-neon transition-colors">{l.label}</Link>
              ))}
            </nav>
          </div>
        </section>
        <section className="pb-24 lg:pb-32">
          <article className="max-w-4xl mx-auto px-6 lg:px-10 space-y-10" data-testid="legal-content">
            {sections.map((s, i) => (
              <div key={s.h} id={s.id} className="border-t border-white/10 pt-8">
                <h2 className="font-display font-bold text-lg md:text-xl text-white flex gap-4">
                  <span className="text-neon text-sm mt-1.5 tabular-nums">{String(i + 1).padStart(2, "0")}</span>{s.h}
                </h2>
                <div className="mt-4 space-y-3 text-sm text-slate-400 leading-relaxed pl-0 md:pl-10">
                  {s.p.map((para, j) => (typeof para === "string" ? <p key={j}>{para}</p> : <div key={j}>{para}</div>))}
                </div>
              </div>
            ))}
            {children}
          </article>
        </section>
      </motion.div>
    </MarketingLayout>
  );
}

export function Bullets({ items }) {
  return (
    <ul className="list-disc pl-5 space-y-1.5">
      {items.map((it) => <li key={it}>{it}</li>)}
    </ul>
  );
}
